import React, { useState } from "react";
import {
  Form,
  Title,
  Input,
  Button,
  ModalOverlay,
  ModalContent,
  CloseButton,
  RecaptchaWrapper,
  InputWrapper,
  ErrorShow,
  ForgotLink,
} from "./style";
import ReCAPTCHA from "react-google-recaptcha";
import { toast } from "react-toastify";
import ForgotModal from "./ForgotModal";
import EmailVerificationModal from "./EmailVerificationModal";
import logoImg from "../assets/logo/Logo.png";

const LoginModal = ({ isOpen, onClose, setLoginUser }) => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    recaptchaValue: "",
  });
  const [errors, setErrors] = useState({});
  const [forgotModalOpen, setForgotModalOpen] = useState(false);
  const [emailVerificationModalOpen, setEmailVerificationModalOpen] =
    useState(false);

  const resetForm = () => {
    setFormData({
      email: "",
      password: "",
      recaptchaValue: "",
    });
    setErrors({});
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.email) newErrors.email = "Email is required";
    if (!formData.password) newErrors.password = "Password is required";
    else if (formData.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters.";
    }
    if (!formData.recaptchaValue)
      newErrors.recaptcha = "Please complete the reCAPTCHA";
    return newErrors;
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    try {
      const response = await fetch(
        "https://admin.whatsappbackupviewer.com/api/login",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: formData.email,
            password: formData.password,
            recaptchaValue: formData.recaptchaValue,
          }),
        }
      );

      const responseData = await response.json();

      if (responseData.user.email_verified_at === null) {
        localStorage.setItem("authToken", JSON.stringify(responseData.token));
        setEmailVerificationModalOpen(true);
        return;
      }

      if (!response.ok) {
        if (responseData.errors && responseData.errors.email) {
          setErrors({ email: responseData.errors.email[0] });
          toast.error(responseData.errors.email[0]);
        } else if (responseData.errors && responseData.errors.password) {
          setErrors({ password: responseData.errors.password[0] });
          toast.error(responseData.errors.password[0]);
        } else {
          throw new Error(
            responseData.errors
              ? JSON.stringify(responseData.errors)
              : "Failed to login"
          );
        }
      } else {
        localStorage.setItem("user", JSON.stringify(responseData));
        setLoginUser(true);
        resetForm();
        onClose();
      }
    } catch (error) {
      console.error("Error during login:", error);
      setErrors({ email: "Invalid credentials" });
      toast.error("Invalid credentials");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleRecaptchaChange = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      recaptchaValue: value,
    }));
  };

  const handleForgotPassword = () => {
    setForgotModalOpen(true);
  };

  const handleForgotClose = () => {
    setForgotModalOpen(false);
  };

  if (!isOpen) return null;

  return (
    <>
      <ModalOverlay />
      {!forgotModalOpen && !emailVerificationModalOpen && (
        <ModalContent>
          <CloseButton
            onClick={() => {
              resetForm();
              onClose();
            }}
          >
            &times;
          </CloseButton>
          <Form onSubmit={handleLogin}>
            <Title>
              <img width={200} src={logoImg} alt="logo" />
            </Title>
            <InputWrapper>
              <Input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleInputChange}
              />
              {errors.email && <ErrorShow>{errors.email}</ErrorShow>}
            </InputWrapper>
            <InputWrapper>
              <Input
                type="password"
                name="password"
                placeholder="Password"
                value={formData.password}
                onChange={handleInputChange}
              />
              {errors.password && <ErrorShow>{errors.password}</ErrorShow>}
            </InputWrapper>
            <InputWrapper>
              <RecaptchaWrapper>
                <ReCAPTCHA
                  sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                  onChange={handleRecaptchaChange}
                />
              </RecaptchaWrapper>
              {errors.recaptcha && <ErrorShow>{errors.recaptcha}</ErrorShow>}
            </InputWrapper>
            <Button type="submit">Login</Button>
            <ForgotLink onClick={handleForgotPassword}>
              Forgot Password?
            </ForgotLink>
          </Form>
        </ModalContent>
      )}
      {forgotModalOpen && (
        <ForgotModal isOpen={forgotModalOpen} onClose={handleForgotClose} />
      )}
      {emailVerificationModalOpen && (
        <EmailVerificationModal
          email={formData.email}
          isOpen={emailVerificationModalOpen}
          onClose={() => setEmailVerificationModalOpen(false)}
        />
      )}
    </>
  );
};

export default LoginModal;
